import React from 'react';

import ServerIO from '../plumbing/ServerIO';
import DataStore from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
import C from '../C';

/**
 * FIXME dont use a global var
 */
let campaigns = null;

/**
 * @deprecated
 */
const combineLists = ({goodLoopVerts}) => { //, appNexusCreatives}) => {
	campaigns = {};
	// Remember which advert IDs belong to which campaigns
	const vertToCampaign = {};

	// Step 1: Group Good-Loop ads by campaign
	goodLoopVerts.forEach(vert => {
		const cid = vert.campaign || `[no campaign: ${vert.id}]`;
		let campaign = campaigns[cid];

		// Make campaign if necessary
		if (!campaign) {
			campaign = { goodloop: {} };
			campaigns[cid] = campaign;
		}

		// Store advert under this campaign
		campaign.goodloop[vert.id] = vert;
		// Store vert-id --> campaign
		vertToCampaign[vert.id] = cid;
	});

	console.log('vertToCampaign', vertToCampaign);

	// // Step 2: For each AppNexus creative, find the Good-Loop ad its VAST url points to,
	// // and group under the Good-Loop campaign that Good-Loop ad belongs to.
	// appNexusCreatives.forEach(creative => {
	// 	// This should be a Good-Loop VAST URL (but might not)
	// 	const mediaUrl = new URL(creative.media_url_secure || creative.media_url); // secure should always be populated, but.

	// 	let vertId = mediaUrl.searchParams.get('gl.vert');
	// 	// It might be wrapped in someone else's VAST URL - but that should have a query param pointing to ours.
	// 	if (!vertId) {
	// 		mediaUrl.searchParams.forEach((val, key) => {
	// 			try {
	// 				const maybeUrl = new URL(val);
	// 				if (maybeUrl.searchParams.has('gl.vert')) {
	// 					vertId = vertId || maybeUrl.searchParams.get('gl.vert');

	// 					if (!vertToCampaign[vertId]) vertToCampaign[vertId] = vertId;
	// 				}
	// 			} catch (error) {} // don't care!
	// 		});
	// 	}
		
	// 	let cid = vertToCampaign[vertId];
	// 	if (!cid) {
	// 		const maybePortalLink = 'https://portal.good-loop.com/#vert/' + vertId;
	// 		console.log('no campaign for advert:', maybePortalLink);
	// 	}

	// 	// finally, get the campaign and 
	// 	let campaign = campaigns[cid];

	// 	if (!campaign) {
	// 		campaign = { goodloop: {} };
	// 		campaigns[cid] = campaign;
	// 	}

	// 	if (!campaign.appnexus) {
	// 		campaign.appnexus = {};
	// 	}

	// 	campaign.appnexus[creative.id] = creative;
	// });

	// // Filter out stuff that doesn't appear on both Good-Loop and AppNexus
	// Object.keys(campaigns).forEach((cid) => {
	// 	if (campaigns[cid].goodloop && !campaigns[cid].appnexus
	// 		|| campaigns[cid].goodloop && !campaigns[cid].appnexus) delete campaigns[cid];
	// });
	console.log(campaigns);
};


function AdOverviewPage() {
	/*
	const pvAds = DataStore.fetch(['list', 'Advert', 'PUBLISHED', 'portal.good-loop.com', 'all', 'unsorted'], () => (
		ServerIO.load('https://portal.good-loop.com/vert/_list.json', {
			data: {
				status: 'ALL_BAR_TRASH',
			}
		})
	));
	*/
	const pvAds = ActionMan.list({type: C.TYPES.Advert, status: C.KStatus.PUBLISHED});

	if (!pvAds.value) { //} || !pvAppNexus.value) {
		return <div> honk </div>;
	}

	if (!campaigns) {
		combineLists({
			goodLoopVerts: pvAds.value.hits
		});
	}


	return <div>
		{Object.entries(campaigns).map(([campaignId, {goodloop}]) => (
			<CampaignCard campaignId={campaignId} goodloop={goodloop} key={campaignId} />
		))}
	</div>;
};

function CampaignCard({ campaignId, goodloop}) {
	let goodLoopInfo = '';

	let glTotalMinViewCount;
	// let anTotalMinViewCount;

	if (goodloop) {
		goodLoopInfo = Object.keys(goodloop).map(id => {
			const evts = DataStore.getValue(['misc', 'logData', 'evts', id]);
			let minViewCount = '';
			if (evts) {
				const bucket = evts.by_evt.buckets.find(bkt => bkt.key === 'minview');
				if (bucket) {
					minViewCount = bucket.doc_count;
					glTotalMinViewCount = (glTotalMinViewCount || 0) + minViewCount;
				}
			}
			return (
				<div key={id}>
					<a href={`https://portal.good-loop.com/#vert/${id}`}><code>{id}</code></a> {minViewCount}
				</div>
			);
		});
	}

	const getGlViews = () => {
		if (!goodloop) return;
		Object.keys(goodloop).forEach(id => {
			DataStore.fetch(['misc', 'logData', 'evts', id], () => (
				ServerIO.getDataLogData({
					q: `vert:${id}`,
					dataspace: 'gl',
					breakdowns: 'evt',
					start: '2019-01-01',
				})
			));
		});
	};

	return (
		<BS.Card>
			<h4>Campaign: {campaignId}</h4>
	
			<h5>Good-Loop Adverts</h5>
			<div>{goodLoopInfo}</div>
			{ glTotalMinViewCount !== undefined ? <p>Minviews: {glTotalMinViewCount}</p> : ''}

		</BS.Card>
	);
};


export default AdOverviewPage;
